import { useState } from 'react';
import { tokens } from '../../../helpers/helperFunctions';
import { ArrowPolygon, Flexed, Select } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconSettingsCheckboxOff,
  IconSettingsCheckboxOn
} from '../../../styles/Icons';
import { SectionSeparator } from '../../../styles/stylesStyled';

import { CollapsibleAbsolute, SelectDropDown } from './SelectNetwork.styles';

interface SelectTokenProps {
  onChange: (token: any) => void;
  value: any;
  isWithdrawSelected?: boolean;
}

export const SelectToken = ({
  onChange,
  value,
  isWithdrawSelected
}: SelectTokenProps) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  return (
    <Select
      isOpen={isOpenDropdown}
      onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
      <span>
        {value ? (
          <Flexed center>
            <img src={value?.icon} alt='checked' />
            <span>{value?.token}</span>
          </Flexed>
        ) : (
          <div style={{ color: color.colors.neutral700 }}>Select Token</div>
        )}
      </span>

      <ArrowPolygon
        direction={isOpenDropdown ? 'down' : 'right'}
        customColor={color.colors.neutral700}
      />

      <CollapsibleAbsolute isOpen={isOpenDropdown}>
        <SelectDropDown>
          {isWithdrawSelected
            ? tokens
                .filter((token) => token.token !== 'USDC')
                .map((token, index) => (
                  <div key={index}>
                    <Flexed
                      between
                      onClick={() => {
                        onChange(token);
                        setIsOpenDropdown(!isOpenDropdown);
                      }}
                      style={{ width: '100%' }}>
                      <Flexed center>
                        <img
                          src={token.icon}
                          alt='checked'
                          style={{ marginRight: 10, width: 14 }}
                        />
                        <span>{token.token}</span>
                      </Flexed>

                      <Icon color={color.colors.secondary100}>
                        {value?.index === index ? (
                          <IconSettingsCheckboxOn size={'24'} />
                        ) : (
                          <IconSettingsCheckboxOff size={'24'} />
                        )}
                      </Icon>
                    </Flexed>
                    <SectionSeparator margin='0' />
                  </div>
                ))
            : tokens.map((token, index) => (
                <div key={index}>
                  <Flexed
                    between
                    onClick={() => {
                      onChange(token);
                      setIsOpenDropdown(!isOpenDropdown);
                    }}
                    key={index}
                    style={{ width: '100%' }}>
                    <Flexed center>
                      <img
                        src={token.icon}
                        alt='checked'
                        style={{ marginRight: 10, width: 14 }}
                      />
                      <span>{token.token}</span>
                    </Flexed>

                    <Icon color={color.colors.secondary100}>
                      {value?.index === index ? (
                        <IconSettingsCheckboxOn size={'24'} />
                      ) : (
                        <IconSettingsCheckboxOff size={'24'} />
                      )}
                    </Icon>
                  </Flexed>
                  <SectionSeparator margin='0' />
                </div>
              ))}
        </SelectDropDown>
      </CollapsibleAbsolute>
    </Select>
  );
};
